<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-button type="primary" @click="dialogAddVisible = true" style="width: 96px">新增类别</el-button>
                </div>
            </div>
            <div>
                <el-table
                        :data="tableData"
                        v-loading="loading"
                        :header-cell-style="{'padding-left': '10%'}"
                        :cell-style="{'padding-left': '10%'}">
                    <el-table-column prop="typeCode" label="类别编码"></el-table-column>
                    <el-table-column prop="typeName" label="类别名称"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editCategory(scope.row)">编辑</el-button>
                            <el-button type="text" @click="openSecondary(scope.row)">次级分类</el-button>
                            <el-button type="text" class="delete-button" @click="deleteCategory(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

        </div>
        <el-dialog title="新增类别" :visible.sync="dialogAddVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelAdd">
            <el-form :model="categoryAdd" :rules="rules" ref="add" size="small">
                <el-form-item label="类别编码" label-width="100px" prop="typeCode">
                    <el-input v-model="categoryAdd.typeCode" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="类别名称" label-width="100px" prop="typeName">
                    <el-input v-model="categoryAdd.typeName" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑类别" :visible.sync="dialogEditVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelEdit">
            <el-form :model="categoryEdit" :rules="rules" ref="edit" size="small">
                <el-form-item label="类别编码" label-width="100px" prop="typeName">
                    <el-input v-model="categoryEdit.typeCode" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="类别名称" label-width="100px" prop="typeName">
                    <el-input v-model="categoryEdit.typeName" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEdit" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="次级分类" :visible.sync="secondaryVisible" width="520px">
            <div class="flex-box" style="margin: -20px 0 10px">
                <el-button plain @click="secondaryAddVisible = true">添加次级分类</el-button>
            </div>
            <el-table :data="secondaryData"
                      height="400px"
                      :header-cell-style="{'padding-left': '10%'}"
                      :cell-style="{'padding-left': '10%'}">
                <el-table-column prop="typeCode" label="次级分类编码"></el-table-column>
                <el-table-column prop="typeName" label="次级分类"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="openSecondaryEdit(scope.row)">编辑</el-button>
                        <el-button type="text" class="delete-button" @click="deleteSecondary(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="secondaryVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="secondaryVisible = false" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加次级分类" :visible.sync="secondaryAddVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelSecondaryAdd">
            <el-form :model="secondaryAdd" :rules="rules" ref="addSecondary" size="small">
                <el-form-item label="编码" label-width="100px" prop="typeCode">
                    <el-input v-model="secondaryAdd.typeCode" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="名称" label-width="100px" prop="typeName">
                    <el-input v-model="secondaryAdd.typeName" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelSecondaryAdd" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmSecondaryAdd" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑次级分类" :visible.sync="secondaryEditVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelSecondaryEdit">
            <el-form :model="secondaryEdit" :rules="rules" ref="editSecondary" size="small">
                <el-form-item label="编码" label-width="100px" prop="typeCode">
                    <el-input v-model="secondaryEdit.typeCode" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="名称" label-width="100px" prop="typeName">
                    <el-input v-model="secondaryEdit.typeName" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelSecondaryEdit" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmSecondaryEdit" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                // 表格信息
                loading: true,
                tableData: [],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 0,
                // 弹窗开关
                dialogAddVisible: false,
                dialogEditVisible: false,
                // 新增弹窗数据
                categoryAdd:{
                    typeName: '',
                },
                rules: {
                    typeName: [{required: true, message: '请输入类别名称', trigger: 'blur'},],
                    typeDetailName: [{required: true, message: '请输入类别名称', trigger: 'blur'},],
                },
                // 编辑弹窗数据
                categoryEdit:{},
                // 次级分类列表
                secondaryVisible: false,
                secondaryData: [],
                typeId: '',
                // 次级分类新增
                secondaryAddVisible: false,
                secondaryAdd: {
                    typeDetailName: ''
                },
                // 次级分类编辑
                secondaryEditVisible: false,
                secondaryEdit: {
                    typeDetailName: ''
                }
            }
        },
        methods: {
            // 获取科室列表
            getData() {
                this.loading = true
                let params = {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                }
                this.axios.post('/api-b/10038/100141',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list !== null) {
                            this.tableData = res.data.data
                        } else {
                            this.$message.info('暂无数据')
                            this.tableData = []
                        }
                        this.total = res.data.data.total
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(() => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.getData()
            },
            // 取消新增
            cancelAdd() {
                this.dialogAddVisible = false
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                })
            },
            // 确定添加产品分类
            confirmAdd() {
                this.$refs.add.validate(valid => {
                    if (valid) {
                        let params = {
                            typeName: this.categoryAdd.typeName
                        }
                        this.axios.post('/api-b/10038/100142',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.dialogAddVisible = false
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.add.resetFields();
                                })
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请按要求正确填写相关信息')
                    }
                })

            },
            // 打开编辑科室弹窗
            editCategory(data) {
                this.axios.get('/api-b/10038/100145/' + data.typeCode,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogEditVisible = true
                        this.categoryEdit = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 取消修改
            cancelEdit() {
                this.dialogEditVisible = false
                this.$nextTick(() => {
                    this.$refs.edit.clearValidate()
                })
            },
            // 确认编辑产品类别
            confirmEdit() {
                this.$refs.edit.validate(valid => {
                    if (valid) {
                        let params = {
                            pharmacyId: this.categoryEdit.pharmacyId,
                            typeId: this.categoryEdit.typeId,
                            typeName: this.categoryEdit.typeName
                        }
                        this.axios.put('/api-b/10038/100144',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.dialogEditVisible = false
                                this.getData()
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请按要求正确填写相关信息')
                    }
                })

            },
            getSecondaryData(data) {
                this.axios.get('/api-b/10039/100149',{
                    params:{
                        "parentCode":data.typeCode
                    },
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.secondaryData = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 打开次级分类
            openSecondary(data) {
                this.getSecondaryData(data)
                this.secondaryVisible = true
            },
            cancelSecondaryAdd() {
                this.secondaryAddVisible = false
                this.$nextTick(() => {
                    this.$refs.addSecondary.resetFields()
                })
            },
            // 确认添加次级分类
            confirmSecondaryAdd() {
                this.$refs.addSecondary.validate(valid => {
                    if (valid) {
                        let params = {
                            typeId: this.typeId,
                            typeDetailName: this.secondaryAdd.typeDetailName
                        }
                        this.axios.post('/api-b/10039/100147/',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.getSecondaryData(this.typeId)
                                this.secondaryAddVisible = false
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请按要求正确填写相关信息')
                    }
                })
            },
            openSecondaryEdit(data) {
                this.secondaryEditVisible =true
                this.secondaryEdit = data
            },
            cancelSecondaryEdit() {
                this.secondaryEditVisible = false
                this.$nextTick(() => {
                    this.$refs.editSecondary.clearValidate()
                })
            },
            confirmSecondaryEdit() {
                this.$refs.editSecondary.validate(valid => {
                    if (valid) {
                        let params = {
                            typeId: this.secondaryEdit.typeId,
                            typeDetailId: this.secondaryEdit.typeDetailId,
                            typeDetailName: this.secondaryEdit.typeDetailName,
                        }
                        this.axios.post('/api-b/10039/100148/',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.getSecondaryData(this.typeId)
                                this.secondaryEditVisible = false
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请按要求正确填写相关信息')
                    }
                })
            },
            deleteSecondary(data) {
                let params = new FormData()
                params.append('typeDetailId',data.typeDetailId)
                this.axios.post('/api-b/10039/100150',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getSecondaryData(this.typeId)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 删除
            deleteCategory(date) {
                this.axios.delete('/api-b/10038/100143/' + date.typeId,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res =>{
                    if(res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            }
        },
        created() {
            this.getData()
        }
    }

</script>
<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .flex-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }
</style>